module.exports = require("@bechtel/client-assets/dist/images/profile-photo.svg");